import {
  ConeGeometry,
  CylinderGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  SphereGeometry
} from 'three';

/** Irelia mesh — blade dancer silhouette. */
export function createIreliaMesh(team = 'blue') {
  const group = new Group();
  const trim = team === 'blue' ? 0xf472b6 : 0xfbbf24;
  const bodyMat = new MeshStandardMaterial({ color: 0x4c0519, roughness: 0.45 });
  const trimMat = new MeshStandardMaterial({ color: trim, roughness: 0.28, metalness: 0.5 });
  const body = new Mesh(new ConeGeometry(0.48, 1.9, 10), bodyMat);
  body.position.y = 1.1;
  group.add(body);
  const head = new Mesh(new SphereGeometry(0.32, 12, 12), trimMat);
  head.position.y = 2.25;
  group.add(head);
  const blade = new Mesh(new CylinderGeometry(0.07, 0.07, 0.65, 5), trimMat);
  blade.rotation.z = -Math.PI / 4;
  blade.position.set(0.55, 1.4, 0.12);
  group.add(blade);
  return group;
}
